import "../CSS/hobbys.css";

import Seo from "../components/Seo";


function HobbysPage() {

    return (

        <>

            <Seo
                title="Hobbys"
                description="Hobbys und persönliche Interessen von Ivan Jörg, darunter Judo, Ju-Jitsu und Lesen."
                canonical="https://www.irj.ch/hobbys"
            />


            <div className="intro">

                <h1>
                    Meine Hobbys
                </h1>

                <p>
                    Hier sind einige meiner Hobbys, die ich früher
                    ausgeübt habe oder heute noch gerne mache.
                </p>

            </div>


            <main>

                <div className="hobbys-container">


                    {/* ==================================================
                        JUDO
                    ================================================== */}

                    <article className="hobby-card">

                        <div className="card-bild">

                            <img
                                src="/Fotos/judo_ich.png"
                                alt="Ivan Jörg beim Judo"
                            />

                        </div>


                        <div className="card-inhalt">

                            <h2>
                                Judo
                            </h2>

                            <p className="card-persoenlich">
                                1991 habe ich mit Judo angefangen und 2022
                                aufgehört. Nebenbei war ich noch im Vorstand
                                und als Trainer tätig und habe den 1. Kyu
                                (brauner Gürtel) erreicht.
                            </p>

                            <h3>
                                Beschreibung Judo
                            </h3>

                            <p>
                                Judo ist eine japanische Kampfsportart und
                                Philosophie, gegründet von Jigoro Kano, die
                                auf dem Prinzip „Siegen durch Nachgeben“
                                (Ju = sanft, Do = Weg) beruht und Körper
                                sowie Geist schult.
                            </p>

                            <p>
                                Der Fokus liegt auf Würfen, Halte-, Hebel-
                                und Würgetechniken. Dabei spielen Respekt,
                                Disziplin, Fairness und der möglichst
                                wirkungsvolle Einsatz der eigenen Kraft
                                eine wichtige Rolle.
                            </p>

                        </div>

                    </article>


                    {/* ==================================================
                        JU-JITSU
                    ================================================== */}

                    <article className="hobby-card">

                        <div className="card-bild">

                            <img
                                src="/Fotos/jj.jpg"
                                alt="Ju-Jitsu"
                            />

                        </div>


                        <div className="card-inhalt">

                            <h2>
                                Ju-Jitsu
                            </h2>

                            <p className="card-persoenlich">
                                Mit Ju-Jitsu habe ich erst später angefangen,
                                als die Judomatten immer härter wurden und
                                ich weniger fallen wollte.
                            </p>

                            <h3>
                                Beschreibung Ju-Jitsu
                            </h3>

                            <p>
                                Ju-Jitsu beziehungsweise Jiu-Jitsu ist eine
                                japanische Selbstverteidigungskunst. Dabei
                                wird versucht, Kraft und Bewegung eines
                                Angreifers gegen ihn selbst zu verwenden,
                                anstatt nur mit eigener Kraft
                                gegenzuhalten.
                            </p>

                            <p>
                                Die Kampfkunst kombiniert unter anderem
                                Schlag-, Tritt-, Wurf-, Hebel- und
                                Würgetechniken. Ziel ist eine möglichst
                                effiziente und flexible Kontrolle oder
                                Abwehr eines Angriffs.
                            </p>

                        </div>

                    </article>


                    {/* ==================================================
                        LESEN
                    ================================================== */}

                    <article className="hobby-card">

                        <div className="card-bild">

                            <img
                                src="/Fotos/bucher.jpg"
                                alt="Bücher"
                            />

                        </div>


                        <div className="card-inhalt">

                            <h2>
                                Lesen
                            </h2>

                            <p className="card-persoenlich">
                                Lesen begleitet mich schon mein ganzes Leben.
                                Ich lese sehr gerne und habe über die Jahre
                                unzählige Bücher und Seiten gelesen.
                            </p>

                            <h3>
                                Meine bevorzugten Bücher
                            </h3>

                            <p>
                                Besonders gerne lese ich Karl-May-Bücher,
                                Krimis und Romane.
                            </p>

                            <p>
                                Für mich ist Lesen eine gute Möglichkeit,
                                abzuschalten, neue Welten kennenzulernen
                                und gleichzeitig die eigene Fantasie
                                anzuregen.
                            </p>

                        </div>

                    </article>


                </div>

            </main>

        </>

    );
}


export default HobbysPage;
